import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


import UserAuthContextProvider from './contexts/UserAuthContext';

import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contactus from './components/pages/Contactus';
import Journey from './components/pages/Journey';
import Aboutus from './components/pages/Aboutus';
import Career from './components/pages/Career';
import Commentary from './components/pages/Commentary';
import Booknow from './components/pages/Booknow';
import ProtectedRouter from "./components/pages/ProtectedRouter";
import UserDashboard from './components/pages/UserDashboard';
import Thanks from './components/pages/Thanks';
import Signup from './components/pages/Signup';
import Login from './components/pages/Login';

function App() {
  return (
    <Router>
         <UserAuthContextProvider>
    
    <div>

     
      
      <Routes>

      <Route axact path="/" element={<Home/>}/>
      <Route axact path="/Contactus" element={<Contactus/>}/>
      <Route axact path="/our-journey" element={<Journey/>}/>
      <Route axact path="/Aboutus" element={<Aboutus/>}/>
      <Route axact path="/career" element={<Career/>}/>
      <Route axact path="/Commentary" element={<Commentary/>}/>
   <Route axact path="/Login" element={<Login/>} />
            <Route axact path="/_______wb______waterstar" element={<Signup/>} />
      <Route axact path="/distributor-book" element={<Booknow/>}/>
            <Route axact path="/thank-you" element={<Thanks/>}/>
                       <Route axact path="/UserDashboard/:userId" element={<ProtectedRouter> <UserDashboard /> </ProtectedRouter>} />

      </Routes>
    <Footer/>
  
    </div>
</UserAuthContextProvider>
    </Router>
  );
}

export default App;
